<template>
  <div>
    <el-form
        ref="ruleFormPackage"
        :model="ruleFormPackage"
        :rules="rules"
        label-position="right"
    >
      <el-form-item label="Tên gói:" prop="name" style="display: flex">
        <el-input
            placeholder="Nhập tên gói..."
            type="text"
            v-model="ruleFormPackage.name"
            autocomplete="off"
            class="no-border"
        />
      </el-form-item>

      <el-form-item label="Mô tả:" prop="description" style="display: flex">
        <el-input
            placeholder="Nhập mô tả cho gói..."
            type="text"
            v-model="ruleFormPackage.description"
            autocomplete="off"
            class="no-border"
        />
      </el-form-item>

      <el-form-item >
        <div style="display: flex; justify-content: end">
          <el-button
              type="success"
              @click="submitForm('ruleFormPackage')"
              icon="el-icon-circle-check"
              :loading="isLoading"
          >
            Lưu
          </el-button>

          <el-button
              type="danger"
              @click="closeForm"
              icon="el-icon-circle-close"
          >
            Đóng
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import {OperationPackage} from "@/services/PackageService";

export default {
  name: 'FormCreateDialogPackage',
  data() {
    return {
      ruleFormPackage: {
        name: "",
        description: "",
      },
      rules: {
        name: [
          { required: true, message: 'Không được để trống trường này!', trigger: 'blur' },
        ],
      },
      isLoading: false,
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fetchSavePackage();
        } else {
          return false;
        }
      });
    },

    resetForm() {
      this.$refs.ruleFormPackage.resetFields();
    },

    closeForm() {
      this.$emit('closeDialogCreate');
    },

    fetchSavePackage() {
      this.isLoading = true;

      OperationPackage.savePackage(this.ruleFormPackage)
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "success",
            });
            this.resetForm();
            this.closeForm();
            this.$store.dispatch("packageStore/fetchDataPackages", true);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              message: "Tạo không thành công!",
              type: "danger",
            });
          })
          .finally(() => {
            this.isLoading = false;
          })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-form-item__content {
  width: 100%;
}
/deep/.no-border .el-input__inner {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  width: 100%;
}

/deep/.el-form-item__label {
  width: 85px;
}
</style>